import { PrivyClientConfig } from '@privy-io/react-auth';
import { toSolanaWalletConnectors } from '@privy-io/react-auth/solana';

export const privyConfig: PrivyClientConfig = {
  loginMethodsAndOrder: {
    primary: ['wallet_connect', 'detected_wallets', 'email', 'twitter'],
    overflow: [
      'google',
      'metamask',
      'binance',
      'coinbase_wallet',
      'rainbow',
      'phantom',
      'solflare',
      'okx_wallet',
      'universal_profile',
      'uniswap',
    ],
  },
  appearance: {
    showWalletLoginFirst: false,
    theme: 'dark',
    accentColor: '#0DFFE0',
    logo: '/mode-logo.svg',
    landingHeader: '',
    walletChainType: 'ethereum-and-solana',
  },
  externalWallets: { solana: { connectors: toSolanaWalletConnectors() } },
};
